import React, { useState, useContext } from 'react';
import { Icon } from '@ok/okd';
import CurrencyInfoContext from '@pages/currencyInfo/context';
import { PLACEHOLDER } from '@pages/currencyInfo/common/context';
import * as classNames from 'classnames';
import { xssPurify } from '@ok/blade';
import { toLocale } from '@common/i18n';

import './index.less';

export default function Faq() {
  const { currencyInfo } = useContext(CurrencyInfoContext);
  const [activeKeys, setActiveKey] = useState([]);

  const handlerClick = (key) => {
    let keys;
    if (activeKeys.includes(key)) {
      keys = activeKeys.filter((k) => {
        return k !== key;
      });
    } else {
      keys = [...activeKeys, key];
    }
    setActiveKey(keys);
  };

  const {
    fullName = PLACEHOLDER,
    symbol = PLACEHOLDER,
    faqs = [],
  } = currencyInfo;

  return (
    faqs.length > 0 && (
      <div className="faq-wrapper">
        <div className="faq-title">
          {toLocale('faq_content_title', {
            symbol,
            currencyFullName: fullName,
          })}
        </div>
        <div className="faq-body">
          {faqs.map(({ title, content }, index) => {
            const isOpen = activeKeys.includes(index);
            const openClassName = isOpen ? 'icon-reverse' : '';
            return (
              <div
                className={classNames('faq-item-box', { active: isOpen })}
                key={index}
                onClick={() => {
                  return handlerClick(index);
                }}
              >
                <div className="faq-item-title">
                  <div className="faq-item-wrapper">{title}</div>
                  <div>
                    <span className="faq-item-right">
                      <Icon
                        className={`okds-arrow-chevron-down-md ${openClassName}`}
                      />
                    </span>
                  </div>
                </div>
                <div
                  className="faq-item-info"
                  onClick={(e) => e.stopPropagation()}
                  dangerouslySetInnerHTML={{ __html: xssPurify(content) }}
                />
              </div>
            );
          })}
        </div>
      </div>
    )
  );
}
